import { render, staticRenderFns } from "./Appt.vue?vue&type=template&id=3ee33c0a&"
import script from "./Appt.vue?vue&type=script&lang=ts&"
export * from "./Appt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports